import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

export const reclassificationModalInitValue = {
  data: {
    date: '',
    lastOperationDate: '',
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    scriptureView: true,
    isReclassificationByClass: true,
    isEntireClassReclassification: false,
    selectedPartner: '',
    selectedPartnerOption: null,
    partnerOptions: [],
    selectedHoldingClass: '',
    holdingClassOptions: [],
    selectedHoldingClassOption: { label: '', value: '' },
    selectedNewHoldingClassOption: { label: '', value: '' },
    selectedNewHoldingClass: '',
    ranges: [],
    totalRanges: 0,
    page: 1,
    rowsPerPage: 10,
    loadingKeys: [],
    disabledKeys: [],
    editedRanges: [],
    historyMovements: [],
    isLoadingRanges: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleChangeIsReclassificationByClass(): void {},
    handleChangeIsEntireClassReclassification(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangeHoldingClass(): void {},
    handleChangeNewHoldingClass(): void {},
    handleFetchHoldingClassByTerm: async (): Promise<
      CustomAsyncSelectOption[] | undefined
    > => undefined,
    handleChangePage(): void {},
    handleChangeRowsPerPage(): void {},
    handleEditRange(): void {},
    handleSaveMovement(): void {},
    handleSaveReclassification(): void {},
  },
};
